import { Wrapper } from '@ahmdigital/ui';
import React from 'react';

import { SHORT_PAGE_TITLE_TEMPLATE } from '../../ahm-constants/ui';
import DecisionTree from './components/decision-tree';
import Head from '../../../utils/head';
import RequestACallDrawer from '../../components/request-a-call/drawer';
import useContacts from './utils/useContacts';

const ContactUsPage = () => {
  useContacts();

  return (
    <>
      <Head titleTemplate={SHORT_PAGE_TITLE_TEMPLATE}>
        <title>Contact ahm | Contact number & details</title>
        <meta
          name="description"
          content="Got questions about health insurance? Chat with us online, via the ahm app, or give us a call. Read on for other insurance queries."
        />
      </Head>
      <Wrapper size="extraExtraLarge">
        <DecisionTree />
      </Wrapper>
      <RequestACallDrawer />
    </>
  );
};

export default ContactUsPage;
